import React from 'react';
import * as Blocks from '../view/FlexibleCard/components/blocks';
import { PreviewBlock, TitleBlock, FooterBlock } from '../view/FlexibleCard/components/blocks';
import * as Elements from '../view/FlexibleCard/components/elements';
export var isFlexibleUiCard = function isFlexibleUiCard(children) {
  if (children && React.Children.toArray(children).some(function (child) {
    return isFlexibleUiTitleBlock(child);
  })) {
    return true;
  }
  return false;
};
export var isFlexibleUiBlock = function isFlexibleUiBlock(node) {
  return /*#__PURE__*/React.isValidElement(node) && Object.values(Blocks).some(function (type) {
    return type === node.type;
  });
};
export var isFlexibleUiElement = function isFlexibleUiElement(node) {
  return /*#__PURE__*/React.isValidElement(node) && Object.values(Elements).some(function (type) {
    return type === node.type;
  });
};
export var isFlexibleUiTitleBlock = function isFlexibleUiTitleBlock(node) {
  return /*#__PURE__*/React.isValidElement(node) && node.type === TitleBlock;
};
export var isFlexibleUiPreviewBlock = function isFlexibleUiPreviewBlock(node) {
  return /*#__PURE__*/React.isValidElement(node) && node.type === PreviewBlock;
};
export var isFlexibleUiFooterBlock = function isFlexibleUiFooterBlock(node) {
  return /*#__PURE__*/React.isValidElement(node) && node.type === FooterBlock;
};